import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_colored_entry_list = _resolveComponent("ontos-colored-entry-list")!
  const _component_ontos_form_dialog = _resolveComponent("ontos-form-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_form_dialog, _mergeProps(_ctx.heading, {
    "max-width": "720px",
    saving: _ctx.saving,
    "save-disabled": !_ctx.changed,
    dirty: _ctx.changed,
    onSave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save())),
    onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closed')))
  }), {
    default: _withCtx(() => [
      _createVNode(_component_ontos_colored_entry_list, {
        ref: "list",
        editable: "",
        entries: _ctx.initial,
        title: _ctx.$tt('roles'),
        "create-label": _ctx.$tt('role-create'),
        "empty-text": _ctx.$tt('roles-empty'),
        "onUpdate:entries": _cache[0] || (_cache[0] = ($event: any) => (_ctx.draft = $event))
      }, null, 8, ["entries", "title", "create-label", "empty-text"])
    ]),
    _: 1
  }, 16, ["saving", "save-disabled", "dirty"]))
}